<section class="financial-institution-select-lab">
  <header class="financial-institution-select-lab__header">
    <h1>Laboratório do seletor de instituição financeira</h1>
    <p>Validação dedicada do wrapper compartilhado para seleção única e múltipla.</p>

    <div class="financial-institution-select-lab__actions">
      <button appButton buttonType="outline" (click)="setMode('ngModel-single')">
        ngModel simples
      </button>
      <button appButton buttonType="outline" (click)="setMode('ngModel-multi')">
        ngModel múltiplo
      </button>
      <button appButton buttonType="outline" (click)="setMode('form-single')">
        FormGroup simples
      </button>
      <button appButton buttonType="outline" (click)="setMode('form-multi')">
        FormGroup múltiplo
      </button>
      <button appButton buttonType="outline" (click)="clearLogs()">Limpar logs</button>
      <button appButton buttonType="primary" (click)="resetStates()">Resetar estados</button>
    </div>
  </header>

  <section class="financial-institution-select-lab__grid">
    <article class="financial-institution-select-lab__card">
      @if (mode === 'ngModel-single') {
        <h2>ngModel simples</h2>

        <app-select-financial-institution
          showClear
          [(ngModel)]="ngModelSingleValue"
          (ngModelChange)="onEvent('ngModel-single.ngModelChange', $event)"
          (optionsLoaded)="onOptionsLoaded($event)"
          (sendfilterChange)="onEvent('ngModel-single.sendfilterChange', $event)"
          (dropdownHide)="onEvent('ngModel-single.dropdownHide')">
        </app-select-financial-institution>

        <pre>{{ ngModelSingleValue | json }}</pre>
      }

      @if (mode === 'ngModel-multi') {
        <h2>ngModel múltiplo</h2>

        <app-select-financial-institution
          [multiple]="true"
          [(ngModel)]="ngModelMultiValue"
          (ngModelChange)="onEvent('ngModel-multi.ngModelChange', $event)"
          (optionsLoaded)="onOptionsLoaded($event)"
          (sendSelectedOptionMultiple)="onEvent('ngModel-multi.sendSelectedOptionMultiple', $event)"
          (sendfilterChange)="onEvent('ngModel-multi.sendfilterChange', $event)"
          (dropdownHide)="onEvent('ngModel-multi.dropdownHide')">
        </app-select-financial-institution>

        <pre>{{ ngModelMultiValue | json }}</pre>
      }

      @if (mode === 'form-single') {
        <h2>FormGroup simples</h2>

        <form [formGroup]="form">
          <app-select-financial-institution
            [formGroup]="form"
            controlName="single"
            (optionsLoaded)="onOptionsLoaded($event)"
            (sendfilterChange)="onEvent('form-single.sendfilterChange', $event)"
            (dropdownHide)="onEvent('form-single.dropdownHide')">
          </app-select-financial-institution>
        </form>

        <pre>{{ form.get('single')?.value | json }}</pre>
      }

      @if (mode === 'form-multi') {
        <h2>FormGroup múltiplo</h2>

        <form [formGroup]="form">
          <app-select-financial-institution
            [multiple]="true"
            [formGroup]="form"
            controlName="multi"
            (optionsLoaded)="onOptionsLoaded($event)"
            (sendfilterChange)="onEvent('form-multi.sendfilterChange', $event)"
            (dropdownHide)="onEvent('form-multi.dropdownHide')">
          </app-select-financial-institution>
        </form>

        <pre>{{ form.get('multi')?.value | json }}</pre>
      }
    </article>

    <article class="financial-institution-select-lab__card">
      <h2>Resumo</h2>
      <pre>Modo atual: {{ mode }}</pre>
      <pre>Opções carregadas: {{ loadedOptionsCount }}</pre>
      <pre *ngIf="logs.length === 0">Sem eventos ainda.</pre>
      <pre *ngIf="logs.length > 0">{{ logs.join('\n') }}</pre>
    </article>
  </section>
</section>
